import { CollapsibleSection } from "components/collapsibleSection";
import Input from "components/input";
import { Label } from "components/label";
import { SwitchButton } from "components/switchButton";
import { Tag } from "components/tag";
import Textarea from "components/textarea";
import { CouponCustomerInfoType, IPromotionCouponDetail, UserType } from "interfaces";
import { Link } from "react-router-dom";
import { canAccessByType, formatNumber } from "utills/helpers";
interface AdditionalSetupProps {
  couponDetailData: IPromotionCouponDetail;
}
export const ViewCouponDetail = ({
  couponDetailData,
}: AdditionalSetupProps) => {
  return (
    <div className="w-full flex flex-col gap-y-2 sm:gap-y-4">
      <div className="w-full box-container">
        <div className="grid gap-x-4 gap-y-4 grid-cols-8 text-sm">
          <div className="col-span-full flex items-center justify-between">
            <p className="font-bold text-base">Coupon Code</p>
            <SwitchButton
              checked={couponDetailData.is_active}
              onChange={() => {}}
              label={couponDetailData.is_active ? "Active" : "Inactive"}
              disabled
            />
          </div>
          <div className="col-span-full sm:col-span-4">
            <Tag
              text={couponDetailData.code}
              customClassName="text-brand-secondary-500 bg-brand-secondary-300 ring-brand-secondary-300"
            />
          </div>

          <div className="col-span-full sm:col-span-2">
            <Label id="usage_count" name="Used Count" />
            {couponDetailData?.usage_count !== null ? (
              <p>{formatNumber(couponDetailData?.usage_count)}</p>
            ) : (
              <p className="text-gray-400">N/A</p>
            )}
          </div>
          <div className="col-span-full sm:col-span-2">
            <Label id="max_times_used" name="Max Time To Use" />
            {couponDetailData?.max_times_used !== null ? (
              <p>{formatNumber(couponDetailData?.max_times_used)}</p>
            ) : (
              <p className="text-gray-400">N/A</p>
            )}
          </div>
          <div className="col-span-full sm:col-span-4">
            <Label id="customer_info_type" name="Customer Info" />
            <div className="flex flex-wrap gap-x-4 text-sm">
              {couponDetailData?.customer_info_type ? (
                <p>
                  {couponDetailData?.customer_info_type ===
                  CouponCustomerInfoType.CODE
                    ? "Customer Code"
                    : couponDetailData?.customer_info_type ===
                      CouponCustomerInfoType.EMAIL
                    ? "Customer Email"
                    : ""}
                </p>
              ) : (
                <></>
              )}
              {couponDetailData?.customer_info_value ? (
                <p>{couponDetailData?.customer_info_value}</p>
              ) : (
                <p className="text-gray-400">N/A</p>
              )}
            </div>
          </div>
          <div className="col-span-full sm:col-span-4">
            <Label id="condition" name="Condition Name" />
            <Link
              to={`/promotion/condition/${couponDetailData?.condition?.id}`}
              target="_blank"
              className="text-brand-500 font-medium hover:underline "
            >
              {couponDetailData?.condition?.note}
            </Link>
          </div>
        </div>
      </div>
      {canAccessByType(UserType.ADMIN) && (
        <CollapsibleSection label="Additional Set-up" defaultOpen={false}>
          <div className="box-container">
            <div className="grid gap-x-4 gap-y-4 grid-cols-8 text-sm">
              <div className="col-span-full">
                <Input
                  type="checkbox"
                  label="Coupon Display"
                  id="couponDisplay"
                  checked={
                    couponDetailData?.displayed_on_actiup ||
                    couponDetailData?.displayed_on_whitelabel
                  }
                  disabled
                />
              </div>
              {(couponDetailData?.displayed_on_actiup ||
                couponDetailData?.displayed_on_whitelabel) && (
                <>
                  <div className="col-span-full flex items-center gap-x-4">
                    <Input
                      type="checkbox"
                      label="Display on ActiUp"
                      id="coupons.displayed_on_actiup"
                      checked={couponDetailData?.displayed_on_actiup}
                      disabled
                    />
                    <Input
                      type="checkbox"
                      label="Display on Whitelabel"
                      id="coupons.displayed_on_whitelabel"
                      checked={couponDetailData?.displayed_on_whitelabel}
                      disabled
                    />
                  </div>
                  <div className="col-span-full">
                    <Label
                      id="coupons.short_desc_vi"
                      name="Coupon Terms of Use"
                    />
                    <div>
                      <div className="relative">
                        <Textarea
                          id="coupons.short_desc_vi"
                          placeholder="Coupon Terms of Use (vi)"
                          className="pr-10"
                          disabled
                          value={couponDetailData?.short_desc_vi}
                        />
                        <img
                          src="/images/flags/circle-vi.png"
                          alt="Language Icon"
                          className="size-5 absolute top-3 right-3"
                        />
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className="relative">
                        <Textarea
                          id="coupons.short_desc_en"
                          placeholder="Coupon Terms of Use (en)"
                          className="pr-10"
                          disabled
                          value={couponDetailData?.short_desc_en}
                        />
                        <img
                          src="/images/flags/circle-en.png"
                          alt="Language Icon"
                          className="size-5 absolute top-3 right-3"
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </CollapsibleSection>
      )}
    </div>
  );
};
